<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.707 22.992C5.30871 23.0241 0.0820308 17.8924 0 11.4977C0 6.42867 3.3465 0.00332761 11.7185 0.00332761C16.4811 -0.107231 20.8781 2.54489 23 6.80798C21.6891 7.6314 19.9727 7.37236 18.9635 6.19878C17.1424 4.19588 14.4991 3.14415 11.799 3.34818C10.0165 3.41715 3.0935 4.71601 3.0935 11.3942C3.0935 18.0725 9.522 19.8311 12.006 19.8196C16.1575 19.8196 16.882 17.6587 19.6075 16.8426C20.5813 16.5785 21.6224 16.8398 22.356 17.5322C19.9967 21.0781 15.9647 23.1453 11.707 22.992Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgCompTIAAppUsers',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>